import React from 'react';

export default function EmptySearchContainer(props) {
    return (
        <div className="search-results" />
    )
}
